<h2>{{viewContext.entityNamePlural | titlecase}}</h2>

<app-array [entities]="entities"
           [listColumns]="getListColumns()"
           [selectedEntity]="selectedEntity"
           (rowOpenRequire)="openCurrentEntityInForm($event)"
           (rowSelected)="onSelect($event)"
           (rowDeleteRequire)="openEntityInDeleteDialog($event)"
           [isShortcutsInUse]="!isOpenViewsOpen()"
           [entityOrder]="entityOrder"
           (headerClicked)="onHeaderClicked($event)"
>
</app-array>

<app-buttons [buttons]="getButtonsMeta()"
             (buttonPressed)="controlButtonPressed($event)"
             [targetSelected]="!!selectedEntity">
</app-buttons>
